import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_GET_BY_ID } from 'api/actionTypes';

export default async function getById({ state, apiClient }, { householdId, forceRefresh = false }) {
  typeCheck('householdId::PositiveNumber', householdId);

  const currentHouseholdStatePath = ['households', 'byId', householdId];
  if (state.get(currentHouseholdStatePath) && !forceRefresh) {
    return state.get(currentHouseholdStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_BY_ID,
    queryId: householdId,
    state: state,
    payload: {
      householdId,
    },
    onSuccess(household) {
      if (household) {
        state.set(currentHouseholdStatePath, household);
      }
    },
  });
}
